import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env, hasPassportAuth, hasSupabase } from '@/config/env';

let client: SupabaseClient | null = null;
let passportAuthClient: SupabaseClient | null = null;

/**
 * HOTTR.me data client (optional until me_* schema is applied on a project).
 * Returns null when env is not configured — no invented credentials.
 */
export const getSupabase = (): SupabaseClient | null => {
  if (!hasSupabase()) return null;
  if (client) return client;
  client = createClient(env.supabaseUrl, env.supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // OFF: Passport SSO lands on /auth/callback?code=… — do not race PKCE.
      detectSessionInUrl: false,
      flowType: 'pkce',
      storageKey: 'hottr.me.auth',
    },
  });
  return client;
};

/**
 * Login / identity client — HOTTR.passport (xsbqsfrfkdhhcscnalqk).
 * Same split as HOTTR.tv: Passport for auth, product project for data when wired.
 */
export const getPassportAuthClient = (): SupabaseClient | null => {
  if (!hasPassportAuth()) return null;
  if (passportAuthClient) return passportAuthClient;

  passportAuthClient = createClient(env.passportSupabaseUrl, env.passportSupabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
      flowType: 'pkce',
      storageKey: 'hottr.passport.auth',
    },
  });

  return passportAuthClient;
};

export const isSupabaseReady = (): boolean => hasSupabase();
